import React from "react";
import styles from "./index.module.scss";
import Link from "next/link";
const Chat = () => {
  return (
    <div className={styles.wrapper}>
      <Link
        className="koh-fixed-find-store-btn md:block hidden"
        href="/storelocator"
      >
        <span className="icon koh-icon-envelope"></span>
        <span className="find-store-text">Find A Store</span>
      </Link>
    </div>
  );
};

export default Chat;
